import type { PropsWithChildren } from 'react';
import { StyleSheetManager } from 'styled-components';
import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import {
  CustomCSS,
  createCustomCSSPrefixClassName,
  EmbedRoot
} from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { meta } from './meta';
import type { BeforeAndAfterSliderSettings } from './types';
import { Widget } from './widget/Widget';

export function BeforeAndAfterSlider(_settings: BeforeAndAfterSliderSettings) {
  return (
    <Providers>
      <Widget />
    </Providers>
  );
}

function Providers({ children }: PropsWithChildren) {
  const { customCSS, customJS, editMode, renderThumbnailMode, widgetId } =
    useSettings();

  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    meta.alias,
    widgetId
  );

  useDefineAPISchema();
  useCustomJS(customJS, editMode || renderThumbnailMode);

  return (
    <StyleSheetManager
      shouldForwardProp={(propName) => !propName.startsWith('_')}
    >
      <CustomCSS
        customCSS={customCSS}
        prefixClassName={customCSSPrefixClassName}
      />
      <EmbedRoot customCSSClassName={customCSSPrefixClassName}>
        {children}
      </EmbedRoot>
    </StyleSheetManager>
  );
}
